import { FETCH_DATA_REQUEST, FETCH_DATA_SUCCESS, FETCH_DATA_FAILURE } from '../actions/actionTypes';
import { defaultAiDashboardSlice } from '../configs/store-config';

const aiDashboard = (state = defaultAiDashboardSlice, action) => {
  switch (action.type) {
    case FETCH_DATA_REQUEST:
      return {
        ...state,
        [action.assetName]: {
          ...state[action.assetName],
          settings: {
            ...state[action.assetName].settings,
            pending: true,
            error: false,
            errorResponse: null,
          },
          ...(action.filters ? { filters: action.filters } : {}),
        },
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        [action.assetName]: {
          ...state[action.assetName],
          data: action.data,
          settings: {
            ...state[action.assetName].settings,
            pending: false,
            loaded: true,
          },
          ...(action.filters ? { filters: action.filters } : {}),
        },
      };
    case FETCH_DATA_FAILURE:
      return {
        ...state,
        [action.assetName]: {
          ...state[action.assetName],
          settings: {
            ...state[action.assetName].settings,
            pending: false,
            error: true,
            errorResponse: action.error,
          },
        },
      };

    default:
      return state;
  }
};

export default aiDashboard;
